import React, { memo, useEffect, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print';
import { PrivateAxios } from '../../../environment/AxiosInstance';
import { UserAuth } from '../../auth/Auth';


function TablePerformance({ startDateInput, endDateInput, setLoading, doer_id }) {

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });

    const { Logout } = UserAuth();

    // const [data, setData] = useState({
    //     "doer_id": "",
    //     "startDate": startDateInput,
    //     "endDate": endDateInput
    // })

    const [taskTrackerChart, setTaskTrackerChart] = useState({
        "todo": 0,
        "inprogress": 0,
        "complete": 0,
        "delay": 0,
        "completeDelay": 0
    })
    const [ChecksheetCharts, setChecksheetCharts] = useState({
        "todo": 0,
        "inprogress": 0,
        "complete": 0,
        "delay": 0,
        "completeDelay": 0
    })
    const [workFlowChart, setworkFlowChart] = useState({
        "todo": 0,
        "inprogress": 0,
        "complete": 0,
        "delay": 0,
        "completeDelay": 0
    })


    const GetTaskTrackerData = (data) => {
        PrivateAxios.post(`report/task-perform/${data.doer_id}`, data)
            .then((res) => {


                const { TodoTask, InprogressTask, CompleteTask, delay, delayComplete } = res.data;
                setTaskTrackerChart({ ...taskTrackerChart, todo: TodoTask, inprogress: InprogressTask, complete: CompleteTask, delay: delay, completeDelay: delayComplete })

            }).catch((err) => {
                setLoading(false)
                if (err.response.status == 401) {
                    Logout();
                }
            })
    }
    const GetChecksheetData = (data) => {
        PrivateAxios.post(`report/checksheet-perform/${data.doer_id}`, data)
            .then((res) => {
                const { TodoTask, InprogressTask, CompleteTask, delay, delayComplete, } = res.data;
                setChecksheetCharts({ ...ChecksheetCharts, todo: TodoTask, inprogress: InprogressTask, complete: CompleteTask, delay: delay, completeDelay: delayComplete })
            }).catch((err) => {
                setLoading(false)
                if (err.response.status == 401) {
                    Logout();
                }
            })
    }
    const GetWorkFlowData = (data) => {
        setLoading(true)
        PrivateAxios.post(`report/workflow-perform/${data.doer_id}`, data)
            .then((res) => {
                setLoading(false)
                const { TodoTask, InprogressTask, CompleteTask, delay, delayComplete } = res.data;
                setworkFlowChart({ ...workFlowChart, todo: TodoTask, inprogress: InprogressTask, complete: CompleteTask, delay: delay, completeDelay: delayComplete })
            }).catch((err) => {
                setLoading(false)
                if (err.response.status == 401) {
                    Logout();
                }
            })
    }

    useEffect(() => {

        if (startDateInput && endDateInput && doer_id) {
            const payload = {
                "doer_id": doer_id,
                "startDate": startDateInput,
                "endDate": endDateInput
            }
            GetTaskTrackerData(payload)
            GetChecksheetData(payload)
            GetWorkFlowData(payload)
        }

    }, [])





    return (
        <table
            className="table table-bordered"
        >
            <tbody>
                <tr>
                    <th>
                        <strong> Checksheet Score</strong>
                    </th>
                    <th

                        className="text-center bg-primary-200"
                    >
                        Planned Task
                    </th>
                    <th
                        className="text-center bg-success-200"
                    >
                        Completed Task
                    </th>
                    <th
                        className="text-center bg-warning-200"
                    >
                        Delayed Task
                    </th>
                    <th
                        className="text-center bg-warning-200"
                    >
                        Delayed Complete
                    </th>
                    <th
                        className="text-center bg-complete-200"
                    >
                        % On Time Complete
                    </th>
                    <th
                        className="text-center bg-error-200"
                    >
                        % Not Completed
                    </th>
                </tr>
                <tr className="odd">
                    <td>All work should be done</td>
                    <td className="text-center">{ChecksheetCharts.todo + ChecksheetCharts.complete + ChecksheetCharts.inprogress + ChecksheetCharts.delay + ChecksheetCharts.completeDelay}</td>
                    <td className="text-center">{ChecksheetCharts.complete}</td>
                    <td className="text-center">{ChecksheetCharts.delay}</td>
                    <td className="text-center">{ChecksheetCharts.completeDelay}</td>
                    <td className="text-center">{(((ChecksheetCharts.complete) / (ChecksheetCharts.todo + ChecksheetCharts.complete + ChecksheetCharts.inprogress + ChecksheetCharts.delay + ChecksheetCharts.completeDelay)) * 100).toFixed(2)}</td>
                    <td className="text-center">{((((ChecksheetCharts.todo + ChecksheetCharts.complete + ChecksheetCharts.inprogress + ChecksheetCharts.delay + ChecksheetCharts.completeDelay) - (ChecksheetCharts.complete + ChecksheetCharts.completeDelay)) / (ChecksheetCharts.todo + ChecksheetCharts.complete + ChecksheetCharts.inprogress + ChecksheetCharts.delay + ChecksheetCharts.completeDelay)) * 100).toFixed(2)}</td>
                </tr>
                <tr className="odd">
                    <th nowrap="">Task Tracker Score</th>
                    <th nowrap="" className="text-center bg-primary-200">
                        Planned Task
                    </th>
                    <th nowrap="" className="text-center bg-success-200">
                        Completed Task
                    </th>
                    <th nowrap="" className="text-center bg-warning-200">
                        Delayed Task
                    </th>
                    <th
                        className="text-center bg-warning-200"
                    >
                        Delayed Complete
                    </th>
                    <th
                        className="text-center bg-complete-200"
                    >
                        % On Time Complete
                    </th>
                    <th nowrap="" className="text-center bg-error-200">
                        % Not Completed
                    </th>
                </tr>

                <tr className="odd">
                    <td>All work should be done</td>
                    <td className="text-center">{taskTrackerChart.todo + taskTrackerChart.complete + taskTrackerChart.inprogress + taskTrackerChart.delay + taskTrackerChart.completeDelay}</td>
                    <td className="text-center">{taskTrackerChart.complete}</td>
                    <td className="text-center">{taskTrackerChart.delay}</td>
                    <td className="text-center">{taskTrackerChart.completeDelay}</td>
                    <td className="text-center">{(((taskTrackerChart.complete) / (taskTrackerChart.todo + taskTrackerChart.complete + taskTrackerChart.inprogress + taskTrackerChart.delay + taskTrackerChart.completeDelay)) * 100).toFixed(2)}</td>
                    <td className="text-center">{((((taskTrackerChart.todo + taskTrackerChart.complete + taskTrackerChart.inprogress + taskTrackerChart.delay + taskTrackerChart.completeDelay) - (taskTrackerChart.complete + taskTrackerChart.completeDelay)) / (taskTrackerChart.todo + taskTrackerChart.complete + taskTrackerChart.inprogress + taskTrackerChart.delay + taskTrackerChart.completeDelay)) * 100).toFixed(2)}</td>
                </tr>
                <tr className="even">
                    <th nowrap="">Work Flow Score</th>
                    <th nowrap="" className="text-center bg-primary-200">
                        Planned Task
                    </th>
                    <th nowrap="" className="text-center bg-success-200">
                        Completed Task
                    </th>
                    <th nowrap="" className="text-center bg-warning-200">
                        Delayed Task
                    </th>
                    <th
                        className="text-center bg-warning-200"
                    >
                        Delayed Complete
                    </th>
                    <th
                        className="text-center bg-complete-200"
                    >
                        % On Time Complete
                    </th>
                    <th nowrap="" className="text-center bg-error-200">
                        % Not Completed
                    </th>
                </tr>
                <tr className="odd">
                    <td>All work should be done</td>
                    <td className="text-center">{workFlowChart.todo + workFlowChart.complete + workFlowChart.inprogress + workFlowChart.delay + workFlowChart.completeDelay}</td>
                    <td className="text-center">{workFlowChart.complete}</td>
                    <td className="text-center">{workFlowChart.delay}</td>
                    <td className="text-center">{workFlowChart.completeDelay}</td>
                    <td className="text-center">{(((workFlowChart.complete) / (workFlowChart.todo + workFlowChart.complete + workFlowChart.inprogress + workFlowChart.delay + workFlowChart.completeDelay)) * 100).toFixed(2)}</td>
                    <td className="text-center">{((((workFlowChart.todo + workFlowChart.complete + workFlowChart.inprogress + workFlowChart.delay + workFlowChart.completeDelay) - (workFlowChart.complete + workFlowChart.completeDelay)) / (workFlowChart.todo + workFlowChart.complete + workFlowChart.inprogress + workFlowChart.delay + workFlowChart.completeDelay)) * 100).toFixed(2)}</td>
                </tr>

            </tbody>
        </table>

    )
}

export default memo(TablePerformance)